<template>
  <div id="login">
    <div class="page_content">
      <StepPassword
        v-if="state === 'PASSWORD' && email"
        @postLogin="handlePostLogin"
        @back="setState('INITIAL')"
        @setState="setState"
        :email="email"
      />

      <StepNewUser
        v-else-if="state === 'NEW_USER' && email"
        @postLogin="handlePostLogin"
        @back="setState('INITIAL')"
        :email="email"
      />

      <StepResetPassword
        v-else-if="state === 'RESET_PASSWORD' && email"
        @back="setState('INITIAL')"
        :email="email"
      />

      <StepMethods
        v-else
        :email="email"
        @changeState="setState"
        @postLogin="handlePostLogin"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useRouter } from "vue-router";
import { sendEmailVerification } from "firebase/auth";
import { ref } from "vue";
import StepMethods from "./StepMethods.vue";
import StepPassword from "./StepPassword.vue";
import StepNewUser from "./StepNewUser.vue";
import StepResetPassword from "./StepResetPassword.vue";

const router = useRouter();

const state = ref<"INITIAL" | "PASSWORD" | "NEW_USER" | "RESET_PASSWORD">("INITIAL");

const email = ref<string>();

const setState = (
  newState: "INITIAL" | "PASSWORD" | "NEW_USER" | "RESET_PASSWORD",
  mail?: string
) => {
  console.log("set state", newState, mail);
  state.value = newState;
  if (mail) {
    email.value = mail;
  }
};

async function handlePostLogin(userCredential: any) {
  const user = userCredential.user;

  if (!user.emailVerified) {
    const res = await sendEmailVerification(user, {
      url: `https://${window.location.host}/u`,
    });
    router.push({ name: "EmailVerification" });
  } else {
    router.push("/u");
  }
}
</script>

<style lang="scss" scoped>
#login {
  background-color: var(--classic-surface, #fff);
  height: calc(100vh - 71px);
  width: 100vw;
  display: flex;
  flex-direction: column;
}

.page_content {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100%;
  padding: 0;
}
</style>
